import { render, staticRenderFns } from "./JurisdictionsColumn.vue?vue&type=template&id=1f176aaf&scoped=true&"
import script from "./JurisdictionsColumn.vue?vue&type=script&lang=js&"
export * from "./JurisdictionsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f176aaf",
  null
  
)

export default component.exports